<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bGe6uB/tc-custom/9780292742529.jpg?1714590723143" alt="This image is the cover for the book Super Black"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Super Black
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A welcome overview of black superheroes and Afrocentric treatments of black-white relations in US superhero comics since the 1960s.” –<i>ImageTexT Journal</i></b></p><p><b>Winner, American Book Award, Before Columbus Foundation</b></p><p><i>Super Black</i> places the appearance of black superheroes alongside broad and sweeping cultural trends in American politics and pop culture, which reveals how black superheroes are not disposable pop products, but rather a fascinating racial phenomenon through which futuristic expressions and fantastic visions of black racial identity and symbolic political meaning are presented. Adilifu Nama sees the value—and finds new avenues for exploring racial identity—in black superheroes who are often dismissed as sidekicks, imitators of established white heroes, or are accused of having no role outside of blaxploitation film contexts.</p><p>Nama examines seminal black comic book superheroes such as Black Panther, Black Lightning, Storm, Luke Cage, Blade, the Falcon, Nubia, and others, some of whom also appear on the small and large screens, as well as how the imaginary black superhero has come to life in the image of President Barack Obama. <i>Super Black</i> explores how black superheroes are a powerful source of racial meaning, narrative, and imagination in American society that express a myriad of racial assumptions, political perspectives, and fantastic (re)imaginings of black identity. The book also demonstrates how these figures overtly represent or implicitly signify social discourse and accepted wisdom concerning notions of racial reciprocity, equality, forgiveness, and ultimately, racial justice.</p><b>“A refreshingly nuanced approach . . . Nama complicates the black superhero by also seeing the ways that they put issues of post-colonialism, race, poverty, and identity struggles front and center.” –<i>Rain Taxi</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adilifu Nama
      </h2>
      
      <p class="authorDescription body article">Adilifu Nama is an Associate Professor at California State University Northridge. He is the author of the award-winning Black Space: Imagining Race in Science Fiction Film, the first book length examination of the topic. Throughout his books, various articles, and presentations, Nama has explored how race and media intersect in television, film, and hip-hop music with a critical eye toward contextualizing black representation along with black racial formation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40efb236